/* Dear eM v24.2 (Claude): gắn ảnh thật của biến thể vào pill chọn biến thể trên trang sản phẩm.
   Ảnh của từng lựa chọn = ảnh của biến thể khớp lựa chọn đó + các lựa chọn khác đang chọn (fallback: biến thể bất kỳ có giá trị đó).
   Chỉ áp dụng cho nhóm lựa chọn có ảnh cho mọi giá trị và có ít nhất 2 ảnh khác nhau. Tự chạy lại khi Dawn vẽ lại khung chọn.
   Nhiều tầng lựa chọn: tầng sau chỉ hiện ra khi khách đã chọn ở tầng trước (link có ?variant= thì hiện hết).
   Điện thoại: mỗi tầng 1 dòng vuốt ngang (CSS), tự cuộn tới ô đang chọn, có dấu hiệu còn ô bên phải. */
(function(){
  var el=document.getElementById('em-vt-data');if(!el)return;
  var data;try{data=JSON.parse(el.textContent).v||[]}catch(e){return}
  if(!data.length)return;
  var revealed=/[?&]variant=/.test(location.search)?99:1;
  var nudged={},reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  function hint(fs){var h=fs.previousElementSibling;if(!h||!h.classList.contains('em-vt-hint')){h=document.createElement('div');h.className='em-vt-hint';h.setAttribute('aria-hidden','true');h.textContent='Vuốt xem thêm →';fs.parentNode.insertBefore(h,fs)}return h}
  function more(fs){var m=!fs.classList.contains('em-vt-hide')&&fs.scrollWidth>fs.clientWidth+4&&fs.scrollLeft+fs.clientWidth<fs.scrollWidth-6;
    if(m!==fs.classList.contains('em-vt-more'))fs.classList.toggle('em-vt-more',m);
    var h=fs.previousElementSibling;if(m)h=hint(fs);if(h&&h.classList.contains('em-vt-hint')&&m!==h.classList.contains('is-on'))h.classList.toggle('is-on',m)}
  function levels(vs){return [].slice.call(vs.querySelectorAll('.product-form__input'))}
  function run(){
    document.querySelectorAll('variant-selects').forEach(function(vs){
      levels(vs).forEach(function(fs,i){
        var hide=i>=revealed;
        if(hide!==fs.classList.contains('em-vt-hide'))fs.classList.toggle('em-vt-hide',hide);
      });
      var fss=[].slice.call(vs.querySelectorAll('fieldset.product-form__input--pill'));
      if(!fss.length)return;
      var sel=fss.map(function(fs){var c=fs.querySelector('input[type=radio]:checked');return c?c.value:null});
      fss.forEach(function(fs,i){
        var inputs=[].slice.call(fs.querySelectorAll('input[type=radio]'));
        if(inputs.length<2)return;
        /* ảnh "riêng" của từng giá trị: ảnh chỉ thuộc về giá trị đó (dùng khi ảnh khớp lựa chọn hiện tại bị trùng giữa các ô) */
        var owner={};data.forEach(function(x){if(!x.i)return;var v=x.o[i];if(owner[x.i]===undefined)owner[x.i]=v;else if(owner[x.i]!==v)owner[x.i]=null});
        var imgs=inputs.map(function(inp){
          var v=inp.value,best=null,any=null,own=null;
          for(var n=0;n<data.length;n++){var x=data[n];if(x.o[i]!==v||!x.i)continue;if(!any)any=x.i;if(!own&&owner[x.i]===v)own=x.i;
            if(best)continue;var ok=true;for(var k=0;k<sel.length;k++){if(k!==i&&sel[k]!=null&&x.o[k]!==sel[k]){ok=false;break}}
            if(ok)best=x.i}
          return {m:best||any,own:own};
        });
        imgs=imgs.map(function(p,j){var dup=imgs.some(function(q,t){return t!==j&&q.m===p.m});return dup&&p.own?p.own:p.m});
        if(imgs.some(function(u){return !u}))return;
        if(!fs.classList.contains('em-vt-on')&&imgs.filter(function(u,j){return imgs.indexOf(u)===j}).length<2)return;
        if(!fs.classList.contains('em-vt-on'))fs.classList.add('em-vt-on');
        inputs.forEach(function(inp,j){
          var lb=fs.querySelector('label[for="'+inp.id+'"]');if(!lb)return;
          var im=lb.querySelector('img.em-vt-img');
          if(!im){im=document.createElement('img');im.className='em-vt-img';im.alt='';im.width=74;im.height=74;im.decoding='async';lb.insertBefore(im,lb.firstChild)}
          if(im.getAttribute('src')!==imgs[j])im.setAttribute('src',imgs[j]);
        });
      });
      /* điện thoại: dòng vuốt ngang – giữ ô đang chọn trong tầm nhìn sau khi Dawn vẽ lại,
         báo còn lựa chọn bên phải (mờ mép phải + dòng "Vuốt xem thêm →" đặt ngoài khung cuộn để không bị cắt), lần đầu hiện thì hé nhẹ sang phải */
      levels(vs).forEach(function(fs,li){
        if(!fs.__emSc){fs.__emSc=1;fs.addEventListener('scroll',function(){more(fs)},{passive:true})}
        if(fs.classList.contains('em-vt-hide')){more(fs);return}
        if(fs.scrollWidth>fs.clientWidth+4&&!fs.__emScrolled){
          fs.__emScrolled=1;
          var c=fs.querySelector('input[type=radio]:checked'),lb=c&&fs.querySelector('label[for="'+c.id+'"]');
          if(lb){var fr=fs.getBoundingClientRect(),lr=lb.getBoundingClientRect();
            if(lr.right>fr.right||lr.left<fr.left)fs.scrollLeft+=lr.left-fr.left-16}
          if(!nudged[li]&&fs.scrollLeft<4&&!reduce){nudged[li]=1;setTimeout(function(){fs.scrollBy({left:56,behavior:'smooth'});setTimeout(function(){fs.scrollBy({left:-56,behavior:'smooth'})},550)},500)}
        }
        more(fs);
      });
    });
  }
  var pending=false;
  function sched(){if(pending)return;pending=true;setTimeout(function(){pending=false;run()},40)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  new MutationObserver(function(ms){for(var i=0;i<ms.length;i++){var t=ms[i].target;if(t.closest&&(t.closest('variant-selects')||t.querySelector&&t.querySelector('variant-selects'))){sched();return}}}).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('change',function(e){
    var vs=e.target&&e.target.closest&&e.target.closest('variant-selects');if(!vs)return;
    var lv=levels(vs),fs=e.target.closest('.product-form__input'),i=lv.indexOf(fs);
    if(i>-1&&i+2>revealed){revealed=i+2;var nx=lv[i+1];if(nx){nx.classList.remove('em-vt-hide');nx.classList.add('em-vt-in')}}
    sched();
  });
})();
